import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import {
  updateAmountInvestment,
  UpdateAmountInvestmentAction
} from 'src/actions/update-amount/UpdateAmountInvestment.actions';
import ChangeAmountComponent, { ChangeAmountComponentProps }
  from 'src/modules/modals/change-amount/ChangeAmount.component';
import Investment from 'src/entities/Investment';
import Project from 'src/entities/Project';
import * as ChangeAmountFormalizationTypes from 'src/actions/update-amount/Types';
import { openModal, OpenModal } from 'src/actions/modal';
import ChangeAmountSuccessComponent from 'src/modules/modals/change-amount/ChangeAmountSuccess';
import * as updateInvestmentTypes from 'src/actions/investment/update/Types';
import { updateInvestment, UpdateInvestmentAction } from 'src/actions/investment/update/UpdateInvestment.actions';
import { getInvestment, GetInvestmentAction } from 'src/actions/investment/get/GetInvestment.actions';
import Person from 'src/entities/Person';

interface StateProps {
  errorMessages: {};
  activeProfile?: Person;
}

interface DispatchProps {
  updateAmountInvestment: (investmentId: number, error: string, message: string) =>
    Promise<UpdateAmountInvestmentAction>;
  openModal: (component: JSX.Element, className: string) => void;
  getInvestment: (projectId: number, profileId: number, profileType: string) => Promise<GetInvestmentAction>;
  updateInvestment: (investment: Investment) => Promise<UpdateInvestmentAction>;
}

interface State {
  error: string;
  message: string;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  investment: Investment;
  project: Project;
}

class ChangeAmountContainer extends React.Component<Props, State> {

  public state = {
    error: '',
    message: ''
  };

  public render(): React.ReactNode {
    return <ChangeAmountComponent {...this.getComponentProps()}/>;
  }

  private handleChange(key: string): (value: string | boolean | File) => void {
    return (value: string | boolean) => {
      const newState = {};
      newState[key] = value;
      this.setState(newState);
    };
  }

  private handleSubmit(): void {
    if (this.props.investment) {
      this.props.updateAmountInvestment(this.props.investment.id!, this.state.error, this.state.message)
        .then((response: UpdateAmountInvestmentAction) => {
          if (response.type === ChangeAmountFormalizationTypes.UPDATE_AMOUNT_INVESTMENT_SUCCESS) {
            this.props.openModal(
              <ChangeAmountSuccessComponent
                modalRef={this.props.modalRef}
              />,
              'large'
            );
            this.props.getInvestment(
              this.props.project.id,
              this.props.activeProfile!.id,
              this.props.activeProfile!.personType
            );
          }
        });
    }
  }

  private handleIsCorrect(): void {
    const investment: Investment = {
      ...this.props.investment!,
      status: 'Confirmed Amount',
      amountInvested:
        ((1.21 * 0.02 + 1) * this.props.investment.amountInvested)
    };
    this.props.updateInvestment(investment)
      .then((updateInvestmentResponse) => {
        if (updateInvestmentResponse.type === updateInvestmentTypes.UPDATE_INVESTMENT_SUCCESS) {
          this.props.getInvestment(
            this.props.project.id,
            this.props.activeProfile!.id,
            this.props.activeProfile!.personType
          );
          this.props.modalRef!.modal('hide');
        }
      });

  }

  private getComponentProps(): ChangeAmountComponentProps {
    return {
      error: this.state.error,
      message: this.state.message,
      errorMessages: this.props.errorMessages,
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      modalRef: this.props.modalRef!,
      investment: this.props.investment,
      project: this.props.project,
      handleIsCorrect: () => this.handleIsCorrect()
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    updateAmountInvestment: (investmentId: number, error: string, message: string):
      Promise<UpdateAmountInvestmentAction> => (
      dispatch(updateAmountInvestment(investmentId, error, message))
    ),
    openModal: (component: JSX.Element, className: string): OpenModal => (
      dispatch(openModal(component, className))
    ),
    getInvestment: (
      projectId: number,
      profileId: number,
      profileType: string
    ): Promise<GetInvestmentAction> => (
      dispatch(getInvestment(projectId, profileId, profileType))
    ),
    updateInvestment: (investment: Investment): Promise<UpdateInvestmentAction> => (
      dispatch(updateInvestment(investment))
    )
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  errorMessages: state.updateChangeAmount.errorMessage,
  activeProfile: state.getUser.activeProfile || undefined,
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeAmountContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/change-amount/ChangeAmount.container.tsx